import React, {Component} from "react";
import "./ViewInquiry.css";
import {FormattedMessage} from "react-intl";
import ShowMoreText from "react-show-more-text";

class ViewReplies extends Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className="color-text">
                {/*<div className="row">
                    <div className="inquiry-reply-row-margin">
                        <div className="col-md-2">
                            <div className="text-right">
                                <label>
                                    <FormattedMessage id="app.inquiry-reply.view"
                                                      defaultMessage="Replied by"
                                                      description=""/>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-9 no-padding-left ">
                            {this.props.replyData.repliedByAdminId}
                        </div>
                    </div>
                </div>*/}
                {this.props.inquiry.userId!==this.props.replyData.replySentByUser ?
                    <div className="row">
                        <div className="">
                            <div className="col-md-6">
                                <div className="inquiry-reply-flow-txt-site flow-txt" id="user-reply-site">管理者&nbsp;
                                    {this.props.replyData.replySentOn.toString().substring(0,4)} 年 {this.props.replyData.replySentOn.toString().substring(5,7)} 月
                                    {this.props.replyData.replySentOn.toString().substring(8,10)} 日&nbsp;&nbsp;{this.props.replyData.replySentOn.toString().substring(11,16)}
                                </div>
                                <div id="view-admin-reply-txt-area-site" className="text-left">
                                    <ShowMoreText
                                        lines={2}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                        {this.props.replyData.replyMessage}
                                    </ShowMoreText>

                                </div>


                            </div>
                        </div>
                    </div>:
                    <div className="row">
                        <div className="col-md-5"></div>
                        <div className=" col-md-7 text-right-align">
                            <text className="inquiry-reply-flow-txt-site-admin">お客様&nbsp;
                                {this.props.replyData.replySentOn.toString().substring(0,4)} 年 {this.props.replyData.replySentOn.toString().substring(5,7)} 月
                                {this.props.replyData.replySentOn.toString().substring(8,10)} 日&nbsp;&nbsp;{this.props.replyData.replySentOn.toString().substring(11,16)}
                            </text>
                            <div className="">
                                <div id="view-my-reply-txt-area-site-admin">
                                    <ShowMoreText
                                        lines={2}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                        {this.props.replyData.replyMessage}
                                    </ShowMoreText>

                                </div>


                            </div>
                        </div>
                    </div>

                }
            </div>
        )
    }

}

export default ViewReplies;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/VIewInquiry/ViewReplies.js